export default __webpack_public_path__ + "static/media/logo.515026c4.svg";